<template>
    <v-app id="inspire">
        <AdminHeader type="search" />
        <v-main class="grey lighten-3">
            <v-container>
                <v-row>
                    <AdminMenu />
                    <v-container class="col-10">
                        <v-row>
                           
                            <v-col class="page-top d-flex justify-space-between" cols="12">
                                <div>
                                    <div class="page-title">Отчеты</div>
                                    <div class="breadcrumb">Отчеты</div>
                                </div>
                            </v-col>
                        </v-row>   
                            <Grid :column="4" :gap="20" :customStyle="{ alignItems: 'flex-start' }" style="margin-top:30px; margin-bottom:30px;" >
                                    <Block :padding="0" :withBorder="true" :overflowHidden="true" style="cursor:pointer;">
                                        <div class="column">
                                            <div class="column__item heading txtact" @click="saleReport = true" >
                                                Отчеты по продажам
                                            </div>
                                            <div class="column__item" @click="saleReport = true" >
                                                Начисление зарплаты
                                            </div>
                                        </div>
                                    </Block>

                                    <Block :padding="0" :withBorder="true" :overflowHidden="true" style="cursor:pointer;" >
                                        <div class="column">
                                            <div class="column__item heading" @click="saleReport = false">
                                                Отчёт по персоналу
                                            </div>
                                            <div class="column__item" @click="saleReport = false">
                                                Табели учета рабочего времени
                                            </div>
                                            <div class="column__item" @click="saleReport = false">
                                                График работы
                                            </div>
                                            <div class="column__item" @click="saleReport = false">
                                                График дежурств
                                            </div>
                                        </div>
                                    </Block>
                                   
                                    </Grid>

                            <v-row>        

                            <v-col cols="12" v-if="saleReport === true">
                                <v-sheet max-height="80px" rounded="lg" class="card tabs-sheet border-gray">
                                    <v-tabs id="horizontal_tabs" v-model="reportShow" centered class="reports-tabs"
                                        height="40">
                                        <v-tab v-for="item in reportType" :key="item.id" class="ml-4">
                                            {{ item.name }}
                                        </v-tab>
                                    </v-tabs>
                                </v-sheet>
                            </v-col>
                            <v-col>
                                <v-tabs-items v-model="reportShow">
                                    <v-tab-item>
                                        <v-sheet class="rounded-lg border-gray">
                                            <v-card-title class="d-flex justify-space-between align-center">
                                                <div class="report-1 filter">
                                                    <div class="left">
                                                        <VueDatePicker no-title no-header v-model="filter.date"
                                                            @onChange="typeToDate(filter.date)" color="#629f34"
                                                            style="flex: none !important;">
                                                            <template #activator="{ date }">
                                                                <button class="custom__date-button" ref="activator"
                                                                    type="button">
                                                                    <v-icon dark small class="mr-2">
                                                                        mdi-calendar-blank-outline
                                                                    </v-icon> {{ date }}
                                                                </button>
                                                            </template>
                                                        </VueDatePicker>
                                                        <v-btn dark class="filter-button" @click="reportGenerate()"
                                                            :disabled="buttonDisabled">
                                                            Сформировать
                                                        </v-btn>
                                                    </div>
                                                    <div class="right">
                                                        <v-btn light class="special-light-button" :disabled="buttonDisabled"
                                                            @click="printTable('table-1')">
                                                            <img src="/playground_assets/printer.svg" alt="">
                                                            Печать
                                                        </v-btn>
                                                    </div>
                                                </div>
                                            </v-card-title>
                                            <div class="scroll-table">
                                                <table id="table-1" cellpadding="1">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th class="no-wrap">Структурная ед.</th>
                                                            <th colspan="2">Продажи</th>
                                                            <th colspan="2">Возвраты</th>
                                                            <th colspan="2" class="no-wrap">Продажи с учетом возвратов</th>
                                                            <th colspan="3">Оплачено</th>
                                                        </tr>
                                                        <tr>
                                                            <th></th>
                                                            <th>Номенклатура</th>
                                                            <th>Количество</th>
                                                            <th>Стоимость</th>
                                                            <th>Количество</th>
                                                            <th>Стоимость</th>
                                                            <th class="font-bold">Количество</th>
                                                            <th class="font-bold">Стоимость</th>
                                                            <th>Оплата</th>
                                                            <th class="no-wrap">Возврат оплаты</th>
                                                            <th class="font-bold">Оплата с уч-м возвратов</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-if="reportData.length > 0">
                                                            <template v-for="line of reportData">
                                                                <tr class="parrent" :key="line.id">
                                                                    <td>
                                                                        <template v-if="line.childrens.length > 0">
                                                                            <button
                                                                                :class="{ 'open-hide': true, open: openParentLine.includes(line.id) }"
                                                                                @click="openChildren(line.id)"></button>
                                                                        </template>
                                                                    </td>
                                                                    <td>{{ line.name }}</td>
                                                                    <td>{{ line.sale_count }}</td>
                                                                    <td class="no-wrap">{{ line.sale_price }} ₽</td>
                                                                    <td>{{ line.return_count }}</td>
                                                                    <td class="no-wrap">{{ line.return_price }} ₽</td>
                                                                    <td>{{ line.sale_return_count }}</td>
                                                                    <td class="no-wrap">{{ line.sale_return_price }} ₽</td>
                                                                    <td class="no-wrap">{{ line.payment }} ₽</td>
                                                                    <td class="no-wrap">{{ line.return_payment }} ₽</td>
                                                                    <td class="no-wrap">{{ line.payment_with_return }} ₽
                                                                    </td>
                                                                </tr>
                                                                <template v-if="line.childrens.length > 0">
                                                                    <template v-for="children of line.childrens">
                                                                        <tr v-if="openParentLine.includes(line.id)"
                                                                            :key="children.id"
                                                                            :class="{ children: true, open: openParentLine.includes(line.id) }">
                                                                            <td> </td>
                                                                            <td>{{ children.name }}</td>
                                                                            <td>{{ children.sale_count }}</td>
                                                                            <td class="no-wrap">{{ children.sale_price }} ₽
                                                                            </td>
                                                                            <td>{{ children.return_count }}</td>
                                                                            <td class="no-wrap">{{ children.return_price }}
                                                                                ₽</td>
                                                                            <td>{{ children.sale_return_count
                                                                            }}
                                                                            </td>
                                                                            <td class="no-wrap">{{
                                                                                children.sale_return_price
                                                                            }} ₽
                                                                            </td>
                                                                            <td>{{ children.payment }}</td>
                                                                            <td class="no-wrap">{{ children.return_payment
                                                                            }} ₽</td>
                                                                            <td class="no-wrap">{{
                                                                                children.payment_with_return }} ₽
                                                                            </td>
                                                                        </tr>
                                                                    </template>
                                                                </template>
                                                            </template>
                                                            <tr class="parrent">
                                                                <td> </td>
                                                                <td class="font-bold">Итого</td>
                                                                <td class="font-bold">15</td>
                                                                <td class="font-bold">9999999 ₽</td>
                                                                <td class="font-bold">Поле</td>
                                                                <td class="font-bold">Поле</td>
                                                                <td class="font-bold">Поле</td>
                                                                <td class="font-bold">Поле</td>
                                                                <td class="font-bold">Поле</td>
                                                                <td class="font-bold">Поле</td>
                                                                <td class="font-bold">Поле</td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </v-sheet>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-sheet class="rounded-lg border-gray">
                                            <v-card-title class="d-flex justify-space-between align-center">
                                                <div class="report-1 filter">
                                                    <div class="left">
                                                        <VueDatePicker no-title no-header v-model="filter.date"
                                                            @onChange="typeToDate(filter.date)" color="#629f34"
                                                            style="flex: none !important;">
                                                            <template #activator="{ date }">
                                                                <button class="custom__date-button" ref="activator"
                                                                    type="button">
                                                                    <v-icon dark small class="mr-2">
                                                                        mdi-calendar-blank-outline
                                                                    </v-icon> {{ date }}
                                                                </button>
                                                            </template>
                                                        </VueDatePicker>
                                                        <v-btn dark class="filter-button" @click="reportGenerate()"
                                                            :disabled="buttonDisabled">
                                                            Сформировать
                                                        </v-btn>
                                                    </div>
                                                    <div class="right">
                                                        <v-btn light class="special-light-button" :disabled="buttonDisabled"
                                                            @click="printTable('table-2')">
                                                            <img src="/playground_assets/printer.svg" alt="">
                                                            Печать
                                                        </v-btn>
                                                    </div>
                                                </div>
                                            </v-card-title>
                                            <div class="scroll-table">
                                                <table id="table-2" cellpadding="1">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th class="font-bold">Клиент</th>
                                                            <th class="font-bold">Сумма</th>
                                                            <th colspan="6" class="font-bold">Зачисления</th>
                                                            <th colspan="5" class="font-bold">Списания</th>
                                                            <th rowspan="2" class="font-bold no-wrap">Сумма Конечный остаток
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th></th>
                                                            <th class="font-bold">Лицевой счет</th>
                                                            <th class="font-bold">Начальный остаток</th>
                                                            <th class="font-bold">Всего (Зачисления)</th>
                                                            <th class="font-bold">Взнос</th>
                                                            <th class="font-bold">Возврат оплаты</th>
                                                            <th class="font-bold">Зачисление сертификата</th>
                                                            <th class="font-bold">Перемещение</th>
                                                            <th class="font-bold">Сумма прочее поступления</th>
                                                            <th class="font-bold">Всего (Списания)</th>
                                                            <th class="font-bold">Оплата</th>
                                                            <th class="font-bold">Возврат взноса</th>
                                                            <th class="font-bold">Перемещение</th>
                                                            <th class="font-bold">Сумма прочее списание</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-if="reportData2.length > 0">
                                                            <template v-for="line of reportData2">
                                                                <tr class="parrent" :key="line.id">
                                                                    <td>
                                                                        <template v-if="line.childrens.length > 0">
                                                                            <button
                                                                                :class="{ 'open-hide': true, open: openParentLine.includes(line.id) }"
                                                                                @click="openChildren(line.id)"></button>
                                                                        </template>
                                                                    </td>
                                                                    <td>{{ line.name }}</td>
                                                                    <td>{{ line.sale_count }}</td>
                                                                    <td class="no-wrap">{{ line.sale_price }} ₽</td>
                                                                    <td>{{ line.return_count }}</td>
                                                                    <td class="no-wrap">{{ line.return_price }} ₽</td>
                                                                    <td>{{ line.sale_return_count }}</td>
                                                                    <td class="no-wrap">{{ line.sale_return_price }} ₽</td>
                                                                    <td class="no-wrap">{{ line.payment }} ₽</td>
                                                                    <td class="no-wrap">{{ line.return_payment }} ₽</td>
                                                                    <td class="no-wrap">{{ line.payment_with_return }} ₽
                                                                    </td>
                                                                    <td class="no-wrap">{{ line.payment_with_return }} ₽
                                                                    </td>
                                                                    <td class="no-wrap">{{ line.payment_with_return }} ₽
                                                                    </td>
                                                                    <td class="no-wrap">{{ line.payment_with_return }} ₽
                                                                    </td>
                                                                    <td class="no-wrap">{{ line.payment_with_return }} ₽
                                                                    </td>
                                                                </tr>
                                                                <template v-if="line.childrens.length > 0">
                                                                    <template v-for="children of line.childrens">
                                                                        <tr v-if="openParentLine.includes(line.id)"
                                                                            :key="children.id"
                                                                            :class="{ children: true, open: openParentLine.includes(line.id) }">
                                                                            <td> </td>
                                                                            <td>{{ children.name }}</td>
                                                                            <td>{{ children.sale_count }}</td>
                                                                            <td class="no-wrap">{{ children.sale_price }} ₽
                                                                            </td>
                                                                            <td>{{ children.return_count }}</td>
                                                                            <td class="no-wrap">{{ children.return_price }}
                                                                                ₽</td>
                                                                            <td>{{ children.sale_return_count
                                                                            }}
                                                                            </td>
                                                                            <td class="no-wrap">{{
                                                                                children.sale_return_price
                                                                            }} ₽
                                                                            </td>
                                                                            <td>{{ children.payment }}</td>
                                                                            <td class="no-wrap">{{ children.return_payment
                                                                            }} ₽</td>
                                                                            <td class="no-wrap">{{
                                                                                children.payment_with_return }} ₽
                                                                            </td>
                                                                            <td class="no-wrap">{{
                                                                                children.payment_with_return }} ₽
                                                                            </td>
                                                                            <td class="no-wrap">{{
                                                                                children.payment_with_return }} ₽
                                                                            </td>
                                                                            <td class="no-wrap">{{
                                                                                children.payment_with_return }} ₽
                                                                            </td>
                                                                            <td class="no-wrap">{{
                                                                                children.payment_with_return }} ₽
                                                                            </td>
                                                                        </tr>
                                                                    </template>
                                                                </template>
                                                            </template>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </v-sheet>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-sheet class="rounded-lg border-gray">
                                            <v-card-title class="d-flex justify-space-between align-center">
                                                <div class="report-3 filter">
                                                    <div class="item">
                                                        <label>Структурная ед.</label>
                                                        <v-select class="rounded-lg custom__select" v-model="filter.uit"
                                                            :items="itemsStrucuUit" item-title="title" item-value="value"
                                                            item-text="title"
                                                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                                            placeholder="Выбрать" append-icon="mdi-chevron-down" outlined
                                                            dense style="height: 48px;margin-top: 10px"
                                                            @change="reportGenerate()" :disabled="buttonDisabled">
                                                        </v-select>
                                                    </div>
                                                    <div class="item">
                                                        <label>Клиент</label>
                                                        <v-select class="rounded-lg custom__select" v-model="filter.client"
                                                            :items="itemsClient" item-title="title" item-value="value"
                                                            item-text="title"
                                                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                                            placeholder="Выбрать" append-icon="mdi-chevron-down" outlined
                                                            dense style="height: 48px;margin-top: 10px"
                                                            @change="reportGenerate()" :disabled="buttonDisabled">
                                                        </v-select>
                                                    </div>
                                                    <div class="item">
                                                        <label>Подразделение</label>
                                                        <v-select class="rounded-lg custom__select"
                                                            v-model="filter.division" :items="itemsDivision"
                                                            item-title="title" item-value="value" item-text="title"
                                                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                                            placeholder="Выбрать" append-icon="mdi-chevron-down" outlined
                                                            dense style="height: 48px;margin-top: 10px"
                                                            @change="reportGenerate()"
                                                            :disabled="buttonDisabled"></v-select>
                                                    </div>
                                                </div>
                                            </v-card-title>
                                            <div class="scroll-table">
                                                <table id="table-3" cellpadding="1">
                                                    <thead>
                                                        <tr>
                                                            <th class="font-bold">Дата</th>
                                                            <th class="font-bold">Номер</th>
                                                            <th class="font-bold">Клиент</th>
                                                            <th class="font-bold">Договор</th>
                                                            <th class="font-bold">Склад</th>
                                                            <th class="font-bold">Сумма</th>
                                                            <th class="font-bold no-wrap">Сумма возврата</th>
                                                            <th class="font-bold">Комментарий</th>
                                                            <th class="font-bold no-wrap">Структурная единица</th>
                                                            <th class="font-bold">Автор</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-if="reportData3.length > 0">
                                                            <template v-for="line of reportData3">
                                                                <tr class="parrent" :key="line.id">
                                                                    <td class="no-wrap td-check">
                                                                        <div>
                                                                            <template v-if="line.check">
                                                                                <Icon iconName="check" width="16"
                                                                                    height="16" viewBox="0 0 16 16"
                                                                                    stroke="#629F33" />
                                                                            </template>
                                                                            <template v-else>
                                                                                <Icon iconName="x" width="16" height="16"
                                                                                    viewBox="0 0 16 16" stroke="#D53025" />
                                                                            </template>
                                                                            {{ line.date }}
                                                                        </div>
                                                                    </td>
                                                                    <td>{{ line.client_number }}</td>
                                                                    <td class="td-client">
                                                                        <div>
                                                                            <div class="ava">
                                                                                <img src="/playground_assets/Image-2.png"
                                                                                    alt="">
                                                                            </div>
                                                                            {{ line.client }}
                                                                        </div>
                                                                    </td>
                                                                    <td>{{ line.number }}</td>
                                                                    <td>{{ line.warehouse }}</td>
                                                                    <td class="no-wrap">{{ line.amount }} ₽</td>
                                                                    <td class="no-wrap">{{ line.return_count }} ₽</td>
                                                                    <td class="no-wrap">{{ line.comment }}</td>
                                                                    <td class="no-wrap">{{ line.uit }}</td>
                                                                    <td class="no-wrap">{{ line.autor }}</td>
                                                                </tr>
                                                            </template>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </v-sheet>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-sheet class="rounded-lg border-gray">
                                            <v-card-title class="d-flex justify-space-between align-center">
                                                <div class="report-1 filter">
                                                    <div class="left">
                                                        <VueDatePicker no-title no-header v-model="filter.date"
                                                            @onChange="typeToDate(filter.date)" color="#629f34"
                                                            style="flex: none !important;">
                                                            <template #activator="{ date }">
                                                                <button class="custom__date-button" ref="activator"
                                                                    type="button">
                                                                    <v-icon dark small class="mr-2">
                                                                        mdi-calendar-blank-outline
                                                                    </v-icon> {{ date }}
                                                                </button>
                                                            </template>
                                                        </VueDatePicker>
                                                        <v-btn dark class="filter-button" @click="reportGenerate()"
                                                            :disabled="buttonDisabled">
                                                            Сформировать
                                                        </v-btn>
                                                    </div>
                                                    <div class="right">
                                                        <v-btn light class="special-light-button" :disabled="buttonDisabled"
                                                            @click="printTable('table-4')">
                                                            <img src="/playground_assets/printer.svg" alt="">
                                                            Печать
                                                        </v-btn>
                                                    </div>
                                                </div>
                                            </v-card-title>
                                            <div class="scroll-table">
                                                <table id="table-4" cellpadding="1">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th class="font-bold no-wrap">Банковский счет, касса, экв.
                                                                терминал</th>
                                                            <th class="font-bold no-wrap">Платежная карта</th>
                                                            <th class="font-bold">Безналичные</th>
                                                            <th class="font-bold">Наличные</th>
                                                            <th class="font-bold">Итого</th>
                                                        </tr>
                                                        <tr>
                                                            <th></th>
                                                            <th class="font-bold">Подразделение</th>
                                                            <th class="font-bold">Сумма</th>
                                                            <th class="font-bold">Сумма</th>
                                                            <th class="font-bold">Сумма</th>
                                                            <th class="font-bold">Сумма</th>
                                                        </tr>
                                                        <tr>
                                                            <th></th>
                                                            <th class="font-bold" colspan="5">Основание</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-if="reportData4.length > 0">
                                                            <template v-for="line of reportData4">
                                                                <tr class="parrent" :key="line.id">
                                                                    <td>
                                                                        <template v-if="line.childrens.length > 0">
                                                                            <button
                                                                                :class="{ 'open-hide': true, open: openParentLine.includes(line.id) }"
                                                                                @click="openChildren(line.id)"></button>
                                                                        </template>
                                                                    </td>
                                                                    <td>{{ line.name }}</td>
                                                                    <td>{{ line.sale_count }}</td>
                                                                    <td class="no-wrap">{{ line.sale_price }} ₽</td>
                                                                    <td>{{ line.return_count }}</td>
                                                                    <td class="no-wrap">{{ line.return_price }} ₽</td>
                                                                </tr>
                                                                <template v-if="line.childrens.length > 0">
                                                                    <template v-for="children of line.childrens">
                                                                        <tr v-if="openParentLine.includes(line.id)"
                                                                            :key="children.id"
                                                                            :class="{ children: true, open: openParentLine.includes(line.id) }">
                                                                            <td> </td>
                                                                            <td>{{ children.name }}</td>
                                                                            <td>{{ children.sale_count }}</td>
                                                                            <td class="no-wrap">{{ children.sale_price }} ₽
                                                                            </td>
                                                                            <td>{{ children.return_count }}</td>
                                                                            <td class="no-wrap">{{
                                                                                children.payment_with_return }} ₽
                                                                            </td>
                                                                        </tr>
                                                                    </template>
                                                                </template>
                                                            </template>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </v-sheet>
                                    </v-tab-item>
                                </v-tabs-items>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-row>
            </v-container>
        </v-main>
        <iframe name="print_frame" width="0" height="0" frameborder="0" src="about:blank"></iframe>
    </v-app>
</template>
<script>
import { globalMethods } from "@/mixins/globalMethods";
import { VueDatePicker } from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import AdminHeader from '@/components/Admin/AdminHeader.vue';
import AdminMenu from '@/components/Admin/AdminMenu.vue';
import Icon from '@/components/Icons.vue';
export default {
    name: 'ReportsAdminDepartment',
    mixins: [globalMethods],
    components: {
        VueDatePicker,
        AdminHeader,
        AdminMenu,
        Icon
    },
    watch: {
        reportShow: function (val, oldValue) {
            if (val != oldValue) {
                this.$set(this, 'filter', {
                    date: new Date(),
                    client: null,
                    uit: null,
                    division: null
                })
                this.$set(this, 'reportData', [])
                this.$set(this, 'reportData2', [])
                this.$set(this, 'reportData3', [])
                this.$set(this, 'reportData4', [])
            }
        }
    },
    data() {
        return {
            saleReport:true,
            itemsStrucuUit: [
                { title: 'Клеверспорт Н. Челны', value: '1' },
                { title: 'Клеверспорт Москва', value: '2' },
                { title: 'Клеверспорт Санкт-Путербург', value: '3' },
            ],
            itemsClient: [
                { title: 'Ковалев А.Ю.', value: '1' },
                { title: 'Сидорова В.П.', value: '2' },
                { title: 'Самойлов К.И.', value: '3' },
            ],
            itemsDivision: [
                { title: 'Подразделение 1', value: '1' },
                { title: 'Подразделение 2', value: '2' },
                { title: 'Подразделение 3', value: '3' },
            ],
            reportType: [
                { id: 0, name: 'Продажа и оплаты' },
                { id: 1, name: 'Движения по лицевым счетам' },
                { id: 2, name: 'Продажи (Список)' },
                { id: 3, name: 'Выручка по подразделениям' }
            ],
            reportShow: 0,
            filter: {
                date: new Date(),
                client: null,
                uit: null,
                division: null
            },
            buttonDisabled: false,
            reportData: [],
            reportData2: [],
            reportData3: [],
            reportData4: [],
            openParentLine: []
        }
    },
    methods: {
        typeToDate(date) {
            this.$set(this.filter, 'date', new Date(date))
        },
        openChildren(id) {
            if (this.openParentLine.includes(id)) {
                this.$delete(this.openParentLine, this.openParentLine.indexOf(id))
            } else {
                this.$set(this, 'openParentLine', [...this.openParentLine, id])
            }
        },
        reportGenerate() {
            this.$set(this, 'buttonDisabled', true)
            this.sendRequest('POST', this.filter, '/generate_report', {}, true, true)
                .then(response => {
                    let reportName = null

                    this.$set(this, 'buttonDisabled', false)

                    if (this.reportShow == 3) {
                        reportName = 'reportData4'
                    } else if (this.reportShow == 2) {
                        this.$set(this, 'reportData3', [
                            {
                                id: 1,
                                check: true,
                                date: '12.12.2022 14:30:52',
                                client_number: '00000210887',
                                client: 'Иванов Иван Иванович',
                                number: 'FG12321415',
                                warehouse: 'Основной',
                                amount: '2 900,00',
                                return_count: '2 900,00',
                                comment: '+7 900 000 00-00',
                                uit: 'Клеверспорт Н. Челны',
                                autor: 'Абрамов А.С.',
                            },
                            {
                                id: 2,
                                check: false,
                                date: '12.12.2022 14:30:52',
                                client_number: '00000210887',
                                client: 'Иванов Иван Иванович',
                                number: 'FG12321415',
                                warehouse: 'Основной',
                                amount: '2 900,00',
                                return_count: '2 900,00',
                                comment: '+7 900 000 00-00',
                                uit: 'Клеверспорт Н. Челны',
                                autor: 'Абрамов А.С.',
                            },
                            {
                                id: 3,
                                check: true,
                                date: '12.12.2022 14:30:52',
                                client_number: '00000210887',
                                client: 'Иванов Иван Иванович',
                                number: 'FG12321415',
                                warehouse: 'Основной',
                                amount: '2 900,00',
                                return_count: '2 900,00',
                                comment: '+7 900 000 00-00',
                                uit: 'Клеверспорт Н. Челны',
                                autor: 'Абрамов А.С.',
                            },
                        ])
                    } else if (this.reportShow == 1) {
                        reportName = 'reportData2'
                    } else if (this.reportShow == 0) {
                        reportName = 'reportData'
                    }
                    if (reportName) {
                        this.$set(this, reportName, [
                            {
                                id: 1,
                                name: 'Клуб 1',
                                sale_count: 10,
                                sale_price: 999999,
                                return_count: 4,
                                return_price: 534343,
                                sale_return_count: 3,
                                sale_return_price: 232323,
                                payment: 232323,
                                return_payment: 232323,
                                payment_with_return: 232323,
                                childrens: [
                                    {
                                        id: 2,
                                        name: 'Пакет 1',
                                        sale_count: 10,
                                        sale_price: 999999,
                                        return_count: 4,
                                        return_price: 534343,
                                        sale_return_count: 3,
                                        sale_return_price: 232323,
                                        payment: 232323,
                                        return_payment: 232323,
                                        payment_with_return: 232323,
                                    },
                                    {
                                        id: 3,
                                        name: 'Пакет 2',
                                        sale_count: 10,
                                        sale_price: 999999,
                                        return_count: 4,
                                        return_price: 534343,
                                        sale_return_count: 3,
                                        sale_return_price: 232323,
                                        payment: 232323,
                                        return_payment: 232323,
                                        payment_with_return: 232323,
                                    },
                                ]
                            },
                            {
                                id: 2,
                                name: 'Клуб 1',
                                sale_count: 10,
                                sale_price: 999999,
                                return_count: 4,
                                return_price: 534343,
                                sale_return_count: 3,
                                sale_return_price: 232323,
                                payment: 232323,
                                return_payment: 232323,
                                payment_with_return: 232323,
                                childrens: []
                            }
                        ])
                    }

                    console.log(response)
                })
                .catch(err => {
                    this.$set(this, 'buttonDisabled', true)
                    this.$store.commit('setError', err)
                })
        },
        printTable(tableID) {
            const style = `<style>@media print {
        td:first-child,
        th:first-child {
            display: none;
        }
}</style>`
            window.frames["print_frame"].document.body.innerHTML = style + '<table>' + document.getElementById(tableID).innerHTML + '</table>';
            window.frames["print_frame"].window.focus();
            window.frames["print_frame"].window.print();
        }
    }
}
</script>
<style scoped lang="scss">
.filter {
    &.report-1 {
        width: 100%;
        display: flex;
        align-items: center;

        .left {
            flex: 1;
            display: flex;
            align-items: center;
        }

        .right {}
    }

    &.report-3 {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;

        .item {
            width: 100%;

            .v-application .primary--text {
                color: #767676 !important;
                caret-color: #767676 !important;

            }
        }
    }
}

.custom__date-button {
    width: 180px;
    height: 23px;
    display: flex;
    padding: 7px;
    max-width: 180px;
    position: relative;
    box-sizing: content-box;
    align-items: center;
    flex-shrink: 0;
    margin-right: 0;
    border-radius: 12px;
    margin-bottom: 0;
    justify-content: center;
    background-color: var(--dl-color-default-primarysuccess) !important;
    font-size: 16px;
    line-height: 24px;
    color: #fff !important;
}

.special-light-button {
    box-shadow: none;
    border-radius: 12px;
    color: #1A1A1A;
    text-transform: none;
    font-size: 13px;
    line-height: 16px;

    img {
        margin-right: 9.33px;
    }
}

.border-gray {
    border: 1px solid #E0E0E0 !important;

}

.scroll-table {
    overflow-x: auto;
    transform: rotateX(180deg);
    -ms-transform: rotateX(180deg);
    -webkit-transform: rotateX(180deg);
    scrollbar-width: thin;
    scrollbar-color: #E0E0E0 #fff;
    border-bottom: 1px solid #E0E0E0;

    &::-webkit-scrollbar {
        height: 12px;
        background: #E0E0E0;
    }

    &::-webkit-scrollbar-track {
        background: #fff;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #E0E0E0;
        border-radius: 8px;
        border: 2px solid #fff;
    }

    table {
        border-collapse: collapse;
        transform: rotateX(180deg);
        -ms-transform: rotateX(180deg);
        -webkit-transform: rotateX(180deg);
        min-width: 100%;

        &#table-3 {
            min-width: 100%;

            .td-check {
                div {
                    display: flex;
                    align-items: center;

                    svg {
                        margin-right: 10px;
                    }
                }
            }

            .td-client {
                div {
                    white-space: nowrap;
                    display: flex;
                    align-items: center;

                    .ava {
                        width: 24px;
                        min-width: 24px;
                        max-width: 24px;
                        height: 24px;
                        min-height: 24px;
                        max-height: 24px;
                        border-radius: 50%;
                        overflow: hidden;
                        margin-right: 8px;

                        img {
                            width: 100%;
                            height: 100%;
                            border-radius: 50%;
                        }
                    }
                }
            }
        }

        &#table-4 {
            width: 100%;
        }

        th {
            vertical-align: top;
        }

        th,
        td {
            background: #fff;
            padding: 10px 12px;
            text-align: left;
            font-family: 'Circe';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 16px;
            color: #000000;
            border: 1px solid #E0E0E0 !important;

            &.font-bold {
                font-weight: bold;
            }

            &.no-wrap {
                white-space: nowrap;
            }

            &:first-child {
                border-left: 0 !important;
            }

            &:last-child {
                border-left: 0 !important;
            }

            .open-hide {
                border: 1px solid #1A1A1A;
                width: 12px;
                height: 12px;
                display: flex;
                justify-content: center;
                border-radius: 2px;

                &::after {
                    content: "+";
                    line-height: 12px;
                }

                &.open {
                    align-items: center;

                    &::after {
                        content: "";
                        display: block;
                        height: 1px;
                        background: #1A1A1A;
                        width: 6px;
                        border-radius: 1px;
                        line-height: 10px;
                    }
                }
            }
        }

        tbody {
            tr {
                &.parrent {
                    td {
                        background: #F1F1F1;
                    }
                }

                &:last-child {
                    td {
                        border-bottom: 0 !important;
                    }
                }
            }
        }
    }
}
.column {
    &__item {
        padding: 12px 15px;
        color: #1A1A1A;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 16px;
        background: #fff;

        &:not(:last-child) {
            border-bottom: 1px solid #E0E0E0;
        }

        &.heading {
            padding: 20px 15px;
            background: #F1F1F1;
            font-size: 16px;
            line-height: 24px;
        }
    }
}
</style>